import { SIDEBAR_INDEX } from "../actions";

export function setSideBarTitle(payload) {
  return { type: SIDEBAR_INDEX, payload };
}
